import React, { Component } from 'react';
import axios from 'axios'
import {Form, Input} from 'semantic-ui-react'
// TODO: change it back to window.location.origin
const BASE_URL = "http://127.0.0.1:4000";

class NewRoundForm extends Component {
  constructor(props){
    super(props)
    this.state = {round_number_value: '',
                  showError: false}
    this.handleTextChange = this.handleTextChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.fileInput = React.createRef();
  }

  handleTextChange(event) {
    this.setState({round_number_value: event.target.value});
  }

  handleSubmit(){
    event.preventDefault();
    let val = this.state.round_number_value;
    if(val === '' || isNaN(val)){
      this.setState({showError: true});
    }
    else{
      var formData = new FormData();
      formData.append("file", this.fileInput.current.files[0]);
      axios.post(BASE_URL+'/admin/load_apps_from_csv', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            "Access-Control-Allow-Origin": "*"
          }
      })
      .then(function (response) {
        alert(response);
        console.log(response);
      })
      .catch(function (error) {
        alert(error);
        console.log(error);
      })
    }
  }  

  render(){
    let text = this.state.showError ? "Invalid round number. Must be integer!" : ""
    return (
      <Form onSubmit={this.handleSubmit}>
        <Form.Field control={Input} label='Round Number' onChange={this.handleTextChange}
          value={this.state.round_number_value}/>
        {text}
        <br />
        <label>
          Upload File:
          <input name="csv_file" type="file" ref={this.fileInput}/>
        </label>
        <br />
        <button type="submit">Upload</button>
      </Form>
    )
  }
}

export default NewRoundForm;


// WEBPACK FOOTER //
// ./src/components/admin/NewRoundForm.js